import { getHost } from '@/src/utils/helpers/get-host';
import JsonLd from '@/src/utils/helpers/jsonld';
import { BreadcrumbType } from '../ui/breadcrumb/types';

interface BreadcrumbSchemaProps {
  breadcrumbList: BreadcrumbType;
  path: string;
}
function createHref(path: string) {
  const host = process.env.HOST || '';
  if (host.endsWith('/') && path.startsWith('/')) {
    return host + path.slice(1);
  }
  return host + path;
}
const BreadcrumbSchema = ({ breadcrumbList, path }: BreadcrumbSchemaProps) => {
  // breadcrumbList[0].url = breadcrumbList[0].url?.replace('/', '') ?? '';
  let host = getHost();
  if (host && !host.includes('www')) {
    host = host.replace('https://', 'https://www.');
  }
  host = host!.replace('com/', 'com');
  const breadcrumbs = [
    {
      title: 'Anasayfa',
      url: host,
    },
    ...breadcrumbList,
  ];
  const itemListElements = breadcrumbs.map((breadcrumb, index) => {
    const href = createHref(path);
    return {
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id':
          index === 0
            ? breadcrumb.url
            : breadcrumb.url === '' || breadcrumb.url === null
              ? `${href}`
              : `${host}${breadcrumb.url}`,
        name: breadcrumb.title,
      },
    };
  });
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: itemListElements,
  };

  return <JsonLd type="BreadcrumbList" scriptKey="breadcrumbList" schema={schema} />;
};

export default BreadcrumbSchema;
